import { settingsService } from '../services';

export const settings = {
    namespaced: true,
    state: {
        all: {},
        default: {}
    },
    actions: {
        getAll({ commit }) {
            commit('getAllRequest');

            return new Promise((resolve, reject) => {
                settingsService.getAll()
                .then(
                    payload => {
                        commit('getAllSuccess', payload)
                        resolve(payload)
                    }, 
                    error => {
                        commit('getAllFailure', error)
                        reject(error)
                    } 
                )
            });
            
        },       

        update({
            commit
        }, dto) {
            commit('defaultRequest');

            return new Promise((resolve, reject) => {
                settingsService.updateExisting(dto)
                    .then(
                        payload => {
                            commit('defaultRequest', payload);
                            resolve(payload)
                        },
                        error => {
                            commit('defaultRequest', error);
                            reject(error)
                        }
                    );
            })
        },
    },
    mutations: {

        defaultRequest(state) {
            state.default = {
                loading: true
            }; 
        },
        defaultSuccess(state, payload) {
            state.default = {
                item: payload,
                loading: false
            }; 
        },
        defaultFailure(state, error) {
            state.default = {
                error,
                loading: false
            }; 
        },

        getAllRequest(state) {
            state.all = { loading: true };
        },
        getAllSuccess(state, data) {
            console.info(data);
            state.all = { items: data };
        },
        getAllFailure(state, error) {
            state.all = { error };
        },
    }
}